import React from 'react';
import './ConstructionBanner.css';

function ConstructionBanner() {
  return (
    <div className="construction-banner">
      <span role="img" aria-label="construction">🚧</span>
      <p>
        Lovely Voicemail Website Under Construction — We can’t wait to serve the world!
      </p>
    </div>
  );
}

export default ConstructionBanner;
